import { render, staticRenderFns } from "./PublicFileUploader.vue?vue&type=template&id=3222ff9d&scoped=true"
import script from "./PublicFileUploader.vue?vue&type=script&lang=js"
export * from "./PublicFileUploader.vue?vue&type=script&lang=js"
import style0 from "./PublicFileUploader.vue?vue&type=style&index=0&id=3222ff9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3222ff9d",
  null
  
)

export default component.exports